module.exports = "./img/e1d3a56396604b5663f25e82649ecc2b.png";